// Medan pulau: tebing tanah di tepi, rumput polos, dan garis grid editor.
import { cssCol } from "./color";
import { hashN } from "./sky";

const lerpPt = (a, b, t) => [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t];

// ---- Tepi pulau melayang: dua sisi tebing tanah di bawah tanah ----
export function drawCliff(ctx, gridToScreen, zoom, GRID_SIZE) {
  const R = gridToScreen(GRID_SIZE, 0), B = gridToScreen(GRID_SIZE, GRID_SIZE), L = gridToScreen(0, GRID_SIZE);
  const base = 60 * zoom + 24;
  const N = 28;
  const faces = [
    [L, B, [126, 90, 58], [86, 60, 38], 0],   // sisi kiri — lebih gelap
    [B, R, [160, 118, 78], [106, 76, 48], 50], // sisi kanan — kena cahaya
  ];
  for (const [A, Z, cTop, cBot, seed] of faces) {
    const tops = [], bots = [];
    for (let i = 0; i <= N; i++) {
      const p = lerpPt(A, Z, i / N);
      const d = base * (1 + 0.4 * (hashN(seed + i * 3.31) - 0.35));
      tops.push(p);
      bots.push([p[0], p[1] + d]);
    }
    ctx.beginPath();
    ctx.moveTo(...tops[0]);
    for (let i = 1; i <= N; i++) ctx.lineTo(...tops[i]);
    for (let i = N; i >= 0; i--) ctx.lineTo(...bots[i]);
    ctx.closePath();
    const yMax = Math.max(...bots.map(p => p[1]));
    const g = ctx.createLinearGradient(0, Math.min(A[1], Z[1]), 0, yMax);
    g.addColorStop(0, cssCol(cTop));
    g.addColorStop(1, cssCol(cBot));
    ctx.fillStyle = g;
    ctx.fill();
    // urat tanah vertikal
    ctx.strokeStyle = "rgba(60,40,24,0.26)";
    ctx.lineWidth = Math.max(1, 1.2 * zoom);
    for (let i = 2; i < N; i += 3) {
      if (hashN(seed + i * 7.7) < 0.4) continue;
      ctx.beginPath();
      ctx.moveTo(tops[i][0], tops[i][1] + 2);
      ctx.lineTo(bots[i][0] + (hashN(seed + i) - 0.5) * 6, bots[i][1] - 3);
      ctx.stroke();
    }
  }
}

// ---- Tanah rumput bertekstur: satu poligon pulau penuh + bintik halus ----
export function groundTiles(ctx, gridToScreen, GRID_SIZE) {
  // Satu poligon pulau penuh — rumput POLOS satu warna (tanpa bintik tekstur).
  const TL = gridToScreen(0, 0), TR = gridToScreen(GRID_SIZE, 0), BR = gridToScreen(GRID_SIZE, GRID_SIZE), BL = gridToScreen(0, GRID_SIZE);
  ctx.fillStyle = cssCol([110, 165, 78]);
  ctx.beginPath();
  ctx.moveTo(...TL); ctx.lineTo(...TR); ctx.lineTo(...BR); ctx.lineTo(...BL);
  ctx.closePath(); ctx.fill();
}

// Garis grid opsional (toggle Grid ON/OFF)
export function drawGridLines(ctx, gridToScreen, GRID_SIZE) {
  ctx.strokeStyle = "rgba(15,23,42,0.12)";
  ctx.lineWidth = 1;
  for (let g = 0; g <= GRID_SIZE; g++) {
    let a = gridToScreen(g, 0), b2 = gridToScreen(g, GRID_SIZE);
    ctx.beginPath(); ctx.moveTo(...a); ctx.lineTo(...b2); ctx.stroke();
    a = gridToScreen(0, g); b2 = gridToScreen(GRID_SIZE, g);
    ctx.beginPath(); ctx.moveTo(...a); ctx.lineTo(...b2); ctx.stroke();
  }
}
